import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CrudService } from 'src/core/services/crud/crud.service';
import { ListResponseDto } from 'src/core/models/request/list-response.dto';
import { OutboundNumberDto } from '../models/outbound-number.dto';
import { PhoneNumberConnectivityResultDto } from '../models/phone-number-connectivity-result.dto';

@Injectable({ providedIn: 'root' })
export class OutboundNumberService {
  private readonly crudService = inject(CrudService);

  getList(skipCount = 0, maxResultCount = 10): Observable<ListResponseDto<OutboundNumberDto>> {
    return this.crudService.get<OutboundNumberDto>(OutboundNumberDto, {
      skipCount,
      maxResultCount,
      filters: [],
      sorters: [],
    });
  }

  getById(id: number): Observable<OutboundNumberDto> {
    return this.crudService.getWithSuffix<OutboundNumberDto>(OutboundNumberDto, id);
  }

  create(dto: OutboundNumberDto): Observable<OutboundNumberDto> {
    return this.crudService.insertWithoutId<OutboundNumberDto>(OutboundNumberDto, dto);
  }

  update(dto: OutboundNumberDto & { id: number }): Observable<OutboundNumberDto> {
    return this.crudService.update<OutboundNumberDto>(
      OutboundNumberDto,
      dto as unknown as { id: number } & Record<string, unknown>,
    );
  }

  delete(id: number): Observable<unknown> {
    return this.crudService.delete(OutboundNumberDto, id);
  }

  activate(id: number): Observable<void> {
    return this.crudService.insertWithoutId<void>(
      OutboundNumberDto,
      {} as unknown as void,
      `${id}/activate`,
    );
  }

  deactivate(id: number): Observable<void> {
    return this.crudService.insertWithoutId<void>(
      OutboundNumberDto,
      {} as unknown as void,
      `${id}/deactivate`,
    );
  }

  setDefault(id: number): Observable<void> {
    return this.crudService.insertWithoutId<void>(
      OutboundNumberDto,
      {} as unknown as void,
      `${id}/set-default`,
    );
  }

  testConnectivity(id: number): Observable<PhoneNumberConnectivityResultDto> {
    return this.crudService.insertWithoutId<PhoneNumberConnectivityResultDto>(
      OutboundNumberDto,
      {} as unknown as PhoneNumberConnectivityResultDto,
      `${id}/test-connectivity`,
    );
  }
}
